// extracted by mini-css-extract-plugin
export default {"wrapper":"V3759","infos":"wfAtZ","content":"btW2U","textContainer":"bHZxH","title":"AA8hC","text":"l5__q"};